import { hasShell, inMacShell, tellShell } from '../lib/shell'
import type { EmailApp } from '../api/types'
import type { BoardStoreOptions } from '../store/store'

/** Captures this document's nonce once; an old store cannot mark a new page ready. */
export function nativeEmailLinkOptions(): Pick<BoardStoreOptions, 'onEmailLinksReady'> {
  const documentId = typeof document === 'undefined' ? null : document.documentElement.getAttribute('data-email-document')
  if (!inMacShell() || !hasShell() || !documentId) return {}
  return { onEmailLinksReady: ready => tellShell({ emailLinksReady: { document: documentId, ready } }) }
}

/**
 * The Mac app this page is in, by the scheme its email links take
 * (`data-email-link-scheme`, mac/Sources/PoulpeMacUI/WindowChrome.swift), so
 * that a link asked for here opens here. Undefined in a browser, or for any
 * other value: the server is sent nothing, and mails the web link.
 */
export function emailLinkApp(): EmailApp | undefined {
  if (!inMacShell()) return undefined
  const scheme = document.documentElement.getAttribute('data-email-link-scheme')
  return scheme === 'poulpe' || scheme === 'poulpe-next-dev' ? scheme : undefined
}
